import { render, staticRenderFns } from "./ProcedureDetailsNew.vue?vue&type=template&id=664878d2&"
import script from "./ProcedureDetailsNew.vue?vue&type=script&lang=js&"
export * from "./ProcedureDetailsNew.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureDetailsNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports